import RAdmin from './admin.routes'
import RStudent from './student.routes'
import RSecurity from './security-personel.routes'
import RShared from './shared.routes'
import { RLanding } from './landing.routes'

const allRoutes = []

export default allRoutes.concat(
  RAdmin,
  RStudent,
  RSecurity,
  RLanding,
  RShared
)
